<script>
    import ProductTypographyToggle from "./ProductTypographyToggle";

    const HEIGHT_MULTIPLE_ROWS = 245; // 49(height) * 5(row)

    export default {
        name: "ProductTypographyParameters",
        components: { ProductTypographyToggle },
        props: {
            parameters: Array,
            equipments: Array,
            parametersTitle: {
                type: String,
                default: "Технические данные",
            },
            equipmentsTitle: {
                type: String,
                default: "Что в коробке",
            },
        },
        data() {
            return {
                currentHeight: HEIGHT_MULTIPLE_ROWS,
                anchorElement: null,
                isActiveState: true,
            };
        },
        computed: {
            createStyle() {
                return `max-height: ${this.currentHeight}${
                    this.currentHeight !== "auto" ? "px" : ""
                }`;
            },
            isMoreState() {
                return this.parameters.length > 4 || this.equipments.length > 0;
            },
        },
        mounted() {
            this.anchorElement = document.querySelector(".js-anchor-parameters");
        },
        methods: {
            toggled() {
                this.anchorElement.scrollIntoView({ behavior: "smooth" });
                this.isActiveState = false;
                this.currentHeight =
                    this.currentHeight === "8000" ? HEIGHT_MULTIPLE_ROWS : "8000";

                if (this.currentHeight !== "8000") {
                    this.isActiveState = true;
                }
            },
        },
    };
</script>

<template>
    <div class="product-typography-parameters">
        <div class="product-anchor-style js-anchor-parameters"></div>
        <div
            v-if="parametersTitle.length > 0 && parameters.length > 0"
            class="product-typography-parameters__title"
        >
            {{ parametersTitle }}
        </div>

        <div
            class="product-typography-parameters__wrapper"
            :class="{ 'product-typography-parameters__wrapper--active': isActiveState }"
        >
            <div class="product-typography-parameters__container" :style="createStyle">
                <ul v-if="parameters.length > 0" class="product-typography-parameters__list">
                    <li
                        v-for="(parameter, i) in parameters"
                        :key="i"
                        class="product-typography-parameters__row"
                    >
                        <span
                            class="product-typography-parameters__cell"
                            v-html="parameter.name"
                        >
                        </span>
                        <span
                            class="product-typography-parameters__cell"
                            v-html="parameter.value"
                        ></span>
                    </li>
                </ul>
                <div
                    v-if="Object.keys(equipments).length > 0"
                    class="product-typography-parameters__equipment"
                >
                    <div
                        v-if="equipmentsTitle.length > 0"
                        class="product-typography-parameters__title"
                    >
                        {{ equipmentsTitle }}
                    </div>
                    <ul class="product-typography-parameters__equipment-list">
                        <li
                            v-for="(equipment, i) in equipments"
                            :key="i"
                            class="product-typography-parameters__equipment-item"
                        >
                            {{ equipment.value }}
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="isActiveState && isMoreState" class="gradient-block"></div>
        </div>

        <product-typography-toggle
            v-if="isMoreState"
            :is-active-state="isActiveState"
            text="характеристики"
            @toggled="toggled"
        ></product-typography-toggle>
    </div>
</template>

<style lang="scss">
    .gradient-block {
        position: absolute;
        z-index: 1;
        left: 0;
        right: 0;
        bottom: 0;
        height: 70px;
        background: var(--product-gradient-block);
    }
    .product-typography-parameters {
        margin-bottom: 32px;
    }

    .product-typography-parameters__title {
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        margin-bottom: 16px;
        color: var(--sub-title-typo);
    }

    .product-typography-parameters__wrapper {
        position: relative;
        margin-bottom: 16px;
    }

    .product-typography-parameters__container {
        overflow: hidden;
        transition: max-height 0.7s ease-in-out;
    }

    .product-typography-parameters__list {
        list-style: none;
    }

    .product-typography-parameters__row {
        padding: 12px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        border-top: 1px solid var(--border-parameters-typo);

        &:last-child {
            border-bottom: 1px solid var(--border-parameters-typo);
        }

        @include bp($bp-desktop-sm) {
            flex-wrap: nowrap;
        }
    }

    .product-typography-parameters__cell {
        font-size: 16px;
        line-height: 24px;
        // picooc color: var(--secondary-text);

        &:nth-child(1) {
            width: 100%;
            flex-shrink: 0;
            color: var(--primary-text--lighter);
            font-weight: var(--products-specs-key-weight);
            // picooc ----

            @include bp($bp-desktop-sm) {
                width: 238px;
                // picooc width: 294px;
            }
        }
        &:nth-child(2) {
            flex-grow: 1;
            font-weight: var(--products-specs-value-weight);
            // picooc font-weight: 500;

            @include bp($bp-desktop-sm) {
                padding-left: 8px;
            }
        }
    }

    .product-typography-parameters__equipment {
        margin-top: 32px;
    }

    .product-typography-parameters__equipment-list {
        margin-top: -8px;
    }

    .product-typography-parameters__equipment-item {
        position: relative;
        font-size: 16px;
        font-weight: var(--product-equipments-weight);
        line-height: 32px;
        color: var(--product-equipments-color);
        padding-left: 8px;

        &:after {
            content: "";
            position: absolute;
            top: 15px;
            left: 0;
            bottom: 0;
            @include box(2px);
            background-color: var(--secondary-text);
            border-radius: 50%;
        }
    }

    //
    // --mod
    //

    .product-typography-parameters__wrapper--active {
        margin-bottom: 0;
    }
</style>
